import * as React from "react";
const SvgPlusIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fillRule="evenodd" viewBox="0 0 24 24" {...props}><path d="M11 2v9H2v2h9v9h2v-9h9v-2h-9V2Z" /></svg>;
export { SvgPlusIcon as ReactComponent };